export default __webpack_public_path__ + "static/media/megane-gallery-1.492d101b.jpg";